<template>
  <video :ref="'video_' + videoId" v-if="fileUrl && thumbnail" :src="fileUrl" @play="videoPlayed(video)" width="100%"
    playsinline muted :autoplay="autoplayVideo" controls controlsList="nodownload noremoteplayback" :poster="thumbnail">
    Invalid video
  </video>
</template>

<script>
import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import AWSUrlApi from "@/services/AWSUrlApi";
import VideoService from "@/services/VideoService";
export default {
  props: ["video", "skipAutoplay", "onCompletion", "src"],
  data() {
    return {
      fileUrl: null,
      thumbnail: null,
      autoplayVideo: false
    };
  },
  created() {
    const size = this.$vuetify.breakpoint.name;
    const os = this.getOS();
    if (this.skipAutoplay) {
      this.autoplayVideo = false;
    } else if (os == 'Mac OS' && size != 'lg' && size != 'xl') {//This should be an ipad
      this.autoplayVideo = false;
    } else {
      this.autoplayVideo = os == 'iOS' ? false : true;
    }
    this.getFileUrl();
    this.getThumbnailUrl();
  },
  methods: {
    bindOnCompletionEvent() {
      const vm = this;
      if (vm && vm.video) {
        setTimeout(function () {
          const videoElement = vm.$refs['video_' + vm.video._id];
          if (videoElement) {
            videoElement.onended = function () {
              /*Do things here!*/
              vm.onCompletion(vm.video);
            };
          }
        }, 2000);
      }
    },
    videoPlayed(v) {
      if (v && v._id)
        VideoService.viewVideo(v._id);
    },
    getFileUrl() {
      if (this.video && this.video.fileUrl) {
        this.videoId = this.video._id;
        const fileUrl = this.video.fileUrl;
        if (fileUrl.indexOf('media/') >= 0) {
          AWSUrlApi()
            .get(fileUrl.replace('media/', ''))
            .then((res) => {
              this.fileUrl = res.data;
              if (this.onCompletion) {
                //This ref is not available for some reason
                this.bindOnCompletionEvent();
              }
            });
        } else if (fileUrl.indexOf('AWSAccessKeyId') < 0) {
          const encodedUrl = encodeURIComponent(fileUrl)
          Api()
            .get("content/url/signed/" + encodedUrl)
            .then(res => {
              this.fileUrl = res.data;
              this.bindOnCompletionEvent();
            })
        } else {
          this.fileUrl = fileUrl;
          this.bindOnCompletionEvent();
        }
      } else if (this.src) {
        if (this.src.indexOf('AWSAccessKeyId') < 0) {
          const d = new Date();
          this.videoId = d.getMilliseconds();
          const encodedUrl = encodeURIComponent(this.src)
          Api()
            .get("content/url/signed/" + encodedUrl)
            .then(res => {
              this.fileUrl = res.data;
              this.bindOnCompletionEvent();
            })
        } else {
          this.fileUrl = this.src;
          this.bindOnCompletionEvent();
        }
      }
    },
    async getThumbnailUrl() {
      if (this.video) {
        if (this.video.thumbnail) {
          //userFile(video.thumbnail)
          if (this.video.thumbnail.indexOf('storage-bjjlink-core-prod') >= 0 || this.video.thumbnail.indexOf('bjjlink-elevate-storage') >= 0) {
            this.thumbnail = this.video.thumbnail;
            return;
          }
          if (this.video.thumbnail.indexOf('media/') >= 0) {
            Api2()
              .get(this.video.thumbnail)
              .then((res) => {
                this.thumbnail = res.data;
              });
          } else {
            const encodedUrl = encodeURIComponent(this.video.thumbnail)
            Api2()
              .get("content/url/signed/" + encodedUrl)
              .then(res => {
                this.thumbnail = res.data;
                console.log(this.thumbnail)
              })
          }
        } else {
          this.thumbnail = '/static/play_background.png';
        }
      }
    },
  },
};
</script>

<style scoped></style>
